// src/components/TawkMessengerWidget.tsx
import { useEffect } from "react";

const TawkMessengerWidget = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/67f4e4bc846b7b190fd1ecb0/1ioa9r12v";
    script.async = true;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default TawkMessengerWidget;
